var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTheme(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.152 13.84L.776 22.215a2.641 2.641 0 103.736 3.735l8.376-8.375-3.736-3.735zm-7.48 11.198a1.64 1.64 0 111.162.482 1.648 1.648 0 01-1.162-.474v-.008z",
    fill: "#63A6C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84 9.52l12.37 12.367-1.573 1.572a1.972 1.972 0 01-2.786-.003l-9.588-9.587a1.971 1.971 0 01.005-2.777L4.841 9.52z",
    fill: "#8DC0D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 12.374l-9.516 9.515L4.828 9.515 14.344 0l7.812 7.81-1.604 2.393-3.856 5.759 5.368-4.856L23.84 9.5l2.88 2.875z",
    fill: "#FFE6B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 12.375l-6.244 6.244c2.176-2.176 3.908-5.2 1.6-7.511l1.776-1.6 2.868 2.867zM26.212 27.746c-.4.164-.828.25-1.26.252a3.242 3.242 0 01-1.62-.444 3.164 3.164 0 01-1.244-3.787l.4-1.044 2.412-6.727.052-.156 2.476 6.887.36 1.024c.568 1.535-.072 3.347-1.576 3.995zM19.548 5.2l-3.092-3.088L14.344 0 8.1 6.243c2.56-2.564 5.16.904 3.032 3.032-2.128 2.127 1.548 5.41 3.48 3.48 1.54-1.557 3.892-3.156 5.944-2.553l1.6-2.4L19.548 5.2z",
    fill: "#F99"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgTheme;